import axios, { AxiosInstance } from 'axios';
import { bindMock } from 'storybook-mock-rest';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.NODE_ENV === 'storybook' ? '' : process.env.API_BASE_URL,
})

if (process.env.NODE_ENV === 'storybook') {
  bindMock(axiosInstance)
}

if (window.localStorage.getItem('token')) {
  axiosInstance.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${window.localStorage.getItem('token')}`
}


export { axiosInstance };
